import keyMirror from '../../utils/keyMirror';

import * as Firebase from "../../firebase";
import {getCurrentDate, isObjectEmpty, isOneDayAgo} from "../../utils/utils";
import {CACHE_KEY} from "../../constants";

export const actionTypes = keyMirror(
    {
        GET_USERS: null,
        // GET_CURRENT_USER: null,
    },
    'User'
);

// Action Creators

// export const getCurrentUser = () => async dispatch => {
//
//     let users = await getUsers();
//
//     dispatch({
//         type: actionTypes.GET_CURRENT_USER,
//         payload: users,
//     });
// }

export const getUsers = (forceRefresh=false) => async dispatch => {

    if (forceRefresh) {
        console.log('getUsers: forceRefresh detected; removing user cache keys and will force refresh')
        localStorage.removeItem(CACHE_KEY.USERS);
        localStorage.removeItem(CACHE_KEY.USERS_CACHE_DATE);
    }

    let cachedUsers = localStorage.getItem(CACHE_KEY.USERS);
    let cachedUsersDate = localStorage.getItem(CACHE_KEY.USERS_CACHE_DATE) ? JSON.parse(localStorage.getItem(CACHE_KEY.USERS_CACHE_DATE)) : null;

    if (cachedUsersDate && isOneDayAgo(cachedUsersDate)) {
        console.log('getUsers: cachedUsers is stale (over 1 day); will force refresh')
        localStorage.removeItem(CACHE_KEY.USERS);
        localStorage.removeItem(CACHE_KEY.USERS_CACHE_DATE);
    }

    console.log('getUsers: cachedUsers', cachedUsers)
    console.log('getUsers: cachedUsersDate', cachedUsersDate)
    console.log('isOneDayAgo', isOneDayAgo(cachedUsersDate))

    let users;
    if (cachedUsers && cachedUsers.length > 0) {
        users = JSON.parse(cachedUsers);
        console.log('cached users', users)
    } else {
        users = await Firebase.getUsers();
        console.log('non-cached users', users)
        localStorage.setItem(CACHE_KEY.USERS, JSON.stringify(users));
        localStorage.setItem(CACHE_KEY.USERS_CACHE_DATE, JSON.stringify(getCurrentDate()));
    }

    dispatch({
        type: actionTypes.GET_USERS,
        payload: users,
    });
}

// Reducer

const initialState = {
    users: [],
};

export default (state = initialState, {type, payload}) => {
    switch (type) {
        case actionTypes.GET_USERS:
            return {
                ...state,
                users: payload,
            };
        // case actionTypes.GET_CURRENT_USER:
        //     return {
        //         ...state,
        //         currentUser: payload,
        //     };

        default:
            return state;
    }
};
